module.exports = __webpack_public_path__ + "img/qushangwang.05128cba.png";